import React from "react";
import { Paper, RaisedButton, TextField, Styles } from "material-ui";
import { Navigation } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";

class Reset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: ""
    };

    this._reset = this._reset.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  _reset() {
    UserActions.resetPassword(
      this.props.location.query.token,
      this.state.password
    );
  }

  getStyles() {
    return {
      page: {
        minHeight: "60vh"
      },
      container: {
        margin: "0 auto",
        marginTop: "10%",
        width: "90%",
        maxWidth: 350,
        padding: 20,
        textAlign: "center",
        borderRadius: 10
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      error: {
        color: "#FF4136"
      },
      innerContent: {
        maxWidth: 240,
        margin: "0 auto"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.page}>
        <Paper style={styles.container}>
          {this.props.resetSuccess ? (
            <div>
              <div>Password reset successfully! Please login again.</div>
              <div style={styles.actions}>
                <RaisedButton
                  label="Return to login"
                  style={{ marginLeft: 12 }}
                  onTouchTap={() => this.context.router.push("/login")}
                  primary={true}
                />
              </div>
            </div>
          ) : (
            <div>
              {this.props.resetErrorMessage ? (
                <div style={styles.error}>
                  Failed to reset password: {this.props.resetErrorMessage}
                </div>
              ) : (
                <div>Almost there&mdash;please enter a new password.</div>
              )}
              <form>
                <div>
                  <TextField
                    hintText="New password"
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                    type="password"
                    disabled={this.props.resetInProgress}
                  />
                </div>
                <div>
                  <TextField
                    hintText="Confirm new password"
                    value={this.state.confirmPassword}
                    onChange={e =>
                      this.setState({ confirmPassword: e.target.value })
                    }
                    errorText={
                      this.state.password !== this.state.confirmPassword
                        ? "The passwords do not match."
                        : null
                    }
                    errorStyle={{ textAlign: "left" }}
                    type="password"
                    onKeyDown={e => {
                      if (e.keyCode === 13) this._reset();
                    }}
                    disabled={this.props.resetInProgress}
                  />
                </div>
                <div style={styles.actions}>
                  <RaisedButton
                    label={
                      this.props.resetInProgress
                        ? "Resetting..."
                        : "Reset password"
                    }
                    disabled={
                      this.props.resetInProgress ||
                      !this.state.password ||
                      this.state.password !== this.state.confirmPassword
                    }
                    primary={true}
                    onTouchTap={this._reset}
                  />
                </div>
              </form>
            </div>
          )}
        </Paper>
      </div>
    );
  }
}

export default connectToStores(Reset);



// WEBPACK FOOTER //
// ./src/app/components/reset.jsx